<template>
  <div class="employment">
    <common-layout>
      <div slot="header">
        <h3>担保需求</h3>
      </div>
      <div slot="container">
        <div class="base-search">
          <el-input
            placeholder="请输入内容"
            v-model="listQuery.keyword"
            class="input-with-select"
            @keyup.enter.native="search"
            clearable
            @clear="search"
            style="width: 240px"
          >
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </div>
        <div class="base-table">
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
            class="table"
          >
            <el-table-column
              type="index"
              :index="
                index => {
                  return index + (listQuery.page - 1) * listQuery.pageSize + 1;
                }
              "
              label="序号"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="investmentFirmsName"
              label="金融机构名称"
              align="center"
            ></el-table-column>
            <el-table-column
              label="企业名称"
              align="center"
              prop="enterprisesHistoryName"
            ></el-table-column>
            <el-table-column
              label="拟融资金额"
              align="center"
              prop="intendedFinancingAmount"
            ></el-table-column>
            <el-table-column
              label="融资期限"
              align="center"
              prop="financingTermName"
            ></el-table-column>
            <el-table-column
              label="融资用途"
              align="center"
              prop="financingPurpose"
            ></el-table-column>
            <el-table-column
              label="可提供担保方式"
              align="center"
              prop="guaranteeTypeName"
            ></el-table-column>
            <el-table-column label="担保状态 " align="center" prop="guaranteeStatus">
              <template slot-scope="{ row }">
                <div>
                  {{
                    row.guaranteeStatus === 5 ? '未担保' : row.guaranteeStatus === 6 ? '拒绝担保'
                      : row.guaranteeStatus === 7
                      ? '已担保'
                      : '无需担保'
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="备注" align="center" prop="remark"></el-table-column>

            <el-table-column width="240px" align="center" label="操作">
              <template slot-scope="{ row }">
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="primary"
                  v-if="row.guaranteeStatus === 5"
                  @click="handleEdit(row)"
                >
                  编辑
                </el-button>
                <el-button class="mini_btn" size="mini" type="primary" @click="handleDetail(row)">
                  详情
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          layout="total, prev, pager, next,jumper"
          :total="total"
          :current-page.sync="listQuery.page"
          style="text-align:left;margin:20px 0"
          :page-size="listQuery.pageSize"
        ></el-pagination>
      </div>
    </common-layout>

    <el-dialog
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      class="warrantDialog"
      @open="open"
    >
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="140px">
        <div class="form-title">融资需求</div>
        <el-form-item label="企业名称" prop="enterprisesHistoryName">
          <el-input
            v-model="ruleForm.enterprisesHistoryName"
            placeholder="请输入企业名称"
            disabled
          ></el-input>
        </el-form-item>

        <el-form-item label="意向金融机构" prop="investmentFirmsName">
          <el-input
            v-model="ruleForm.investmentFirmsName"
            placeholder="请输入意向金融机构"
            disabled
          ></el-input>
        </el-form-item>

        <el-form-item label="拟融资金额" prop="intendedFinancingAmount">
          <el-input
            v-model="ruleForm.intendedFinancingAmount"
            type="number"
            placeholder="请输入拟融资金额"
            disabled
          ></el-input>
        </el-form-item>

        <el-form-item label="融资用途" prop="financingPurpose">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            placeholder="请输入融资用途"
            v-model="ruleForm.financingPurpose"
            disabled
          ></el-input>
        </el-form-item>

        <el-form-item label="融资期限" prop="financingTermId">
          <el-select
            v-model="ruleForm.financingTermId"
            placeholder="请选择融资期限"
            disabled
            clearable
            @change="selectChange($event, financingTermList, 'financingTermName')"
          >
            <el-option
              :label="item.label"
              :value="item.id"
              v-for="item in financingTermList"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="可提供担保方式" prop="guaranteeTypeId">
          <el-select
            v-model="ruleForm.guaranteeTypeId"
            placeholder="请选择可提供担保方式"
            disabled
            clearable
            @change="selectChange($event, guaranteeTypeList, 'guaranteeTypeName')"
          >
            <el-option
              :label="item.label"
              :value="item.id"
              v-for="item in guaranteeTypeList"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="担保机构:" prop="guaranteeInstitutionState">
          <el-radio-group v-model="ruleForm.guaranteeInstitutionState" disabled>
            <el-radio :label="0">不需要</el-radio>
            <el-radio :label="1">需要</el-radio>
          </el-radio-group>
          <el-input
            v-model="ruleForm.guaranteeInstitutionName"
            v-if="ruleForm.guaranteeInstitutionState === 1"
            placeholder="请选择担保机构"
            disabled
          ></el-input>
        </el-form-item>
        <div class="form-title">企业信息</div>

        <el-row>
          <el-col :span="12">
            <el-form-item label="企业名称" prop="enterpriseName">
              <el-input
                v-model="ruleForm.enterpriseName"
                placeholder="请输入企业名称"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="组织机构代码" prop="organizationCode">
              <el-input
                v-model="ruleForm.organizationCode"
                placeholder="请输入组织机构代码"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="企业法人" prop="legalPerson">
              <el-input
                v-model="ruleForm.legalPerson"
                placeholder="请输入企业法人"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="联系方式" prop="legalPersonPhone">
              <el-input
                v-model="ruleForm.legalPersonPhone"
                placeholder="请输入联系方式"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="财务负责人" prop="financialLeader">
              <el-input
                v-model="ruleForm.financialLeader"
                placeholder="请输入财务负责人"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="联系方式" prop="financialLeaderPhone">
              <el-input
                v-model="ruleForm.financialLeaderPhone"
                placeholder="请输入联系方式"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系人" prop="contactPerson">
              <el-input
                v-model="ruleForm.contactPerson"
                placeholder="请输入联系人"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="联系方式" prop="contactPersonPhone">
              <el-input
                v-model="ruleForm.contactPersonPhone"
                placeholder="请输入联系方式"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="成立时间" prop="establishDate">
              <el-date-picker
                style="width: 100%"
                v-model="ruleForm.establishDate"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择成立时间"
                disabled
              ></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="纳税地点" prop="taxLocation">
              <el-input
                v-model="ruleForm.taxLocation"
                placeholder="请输入纳税地点"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 三联动地点 -->
        <el-row>
          <el-col :span="12">
            <el-form-item label="注册地址" prop="registeredAddress">
              <v-distpicker
                style="text-align:left;"
                @selected="citySelected1"
                :province="registeredAddress[0]"
                :city="registeredAddress[1]"
                :area="registeredAddress[2]"
                disabled
              ></v-distpicker>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="margin-left: -80px;">
            <el-form-item prop="physicalAddressDetail">
              <el-input
                v-model="ruleForm.registeredAddressDetail"
                disabled
                placeholder="请填写详细地址"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="实际地址" prop="physicalAddress">
              <v-distpicker
                style="text-align:left;"
                @selected="citySelected"
                :province="physicalAddress[0]"
                :city="physicalAddress[1]"
                :area="physicalAddress[2]"
                disabled
              ></v-distpicker>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="margin-left: -80px;">
            <el-form-item prop="registeredAddressDetail">
              <el-input
                v-model="ruleForm.physicalAddressDetail"
                disabled
                placeholder="请填写详细地址"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="所属区域">
              <el-input
                  size="small"
                  label-width="0"
                  placeholder="请填写所属区域"
                  v-model="ruleForm.areaStr"
                  disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属行业">
              <el-input
                  size="small"
                  label-width="0"
                  placeholder="请填写所属行业"
                  v-model="ruleForm.industryStr"
                  disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="主要经营产品" prop="mainProduct">
          <el-input
            v-model="ruleForm.mainProduct"
            placeholder="请填写主要经营产品"
            disabled
          ></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="上年度末总资产" prop="employer">
              <el-input
                v-model="ruleForm.lastYearTotalAssets"
                placeholder="请填写主要经营产品"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="上年度销售收入" prop="employer">
              <el-input
                v-model="ruleForm.lastYearSalesRevenue"
                placeholder="请填写主要经营产品"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="自主知识产权数量" prop="independentRightCount">
              <el-input v-model="ruleForm.independentRightCount" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="公司简介" prop="introduction">
              <el-input
                  type="textarea"
                  :autosize="{ minRows: 4, maxRows: 6 }"
                  placeholder=" 请填写公司简介"
                  v-model="ruleForm.introduction"
                  disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="form-title">审核信息</div>

        <el-row>
          <el-col :span="12">
            <el-form-item label="审核状态" prop="guaranteeStatus">
              <el-select
                style="width: 100%"
                v-model="ruleForm.guaranteeStatus"
                :disabled="disabled"
                placeholder="请选择"
              >
                <el-option :value="5" label="未担保"></el-option>
                <el-option :value="6" label="拒绝担保"></el-option>
                <el-option :value="7" label="已担保"></el-option>
                <el-option :value="8" label="无需担保"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="审核意见" prop="auditOpinion">
              <el-input
                v-model="ruleForm.auditOpinion"
                placeholder="请填写审核意见"
                :disabled="disabled"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="附件上传" prop="fileList">
          <el-upload
            class="upload-demo"
            :action="this.uploadURL"
            style="text-align: left;"
            :disabled="disabled && ruleForm.guaranteeStatus === 5"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'fileList')"
            :file-list="fileList"
            :on-success="
              (response, file, fileList) =>
                handleAvatarSuccess(response, file, fileList, 'fileList')
            "
            list-type="picture"
          >
            <el-button
              size="small"
              type="primary"
              :disabled="disabled && ruleForm.guaranteeStatus === 5"
            >
              上传附件材料
            </el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeForm('ruleForm')">取 消</el-button>
        <el-button
          type="primary"
          @click="updateSubmitForm('ruleForm')"
          v-show="dialogType === 'edit'"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import CommonLayout from "../../../components/common-layout.vue";
import {DownLoadUrl} from "@/utils/tool";
export default {
  components: {
    CommonLayout
  },
  data() {
    return {
      registeredAddress: [],
      physicalAddress: [],
      queryId: '',
      disabled: false,
      accessoryMaterialsSrc: [],
      areaList: [],
      dialogType: '',
      listQuery: {
        keyword: '',
        is_page: 0,
        page: 1,
        pageSize: 10
      },
      deleteRow: [],
      financingTermList: [],
      guaranteeTypeList: [],
      rencaiList: [],
      jishuList: [],
      total: 10,
      Title: "",
      searchValue: "",
      dialogFormVisible: false,
      dialogVisible: false,
      tableData: [],
      ruleForm: {
        // 融资需求
        enterprisesHistoryId: '', // 企业快照id
        enterprisesHistoryName: '', // 企业快照名称
        investmentFirmsId: '', // 意向金融/投资机构id
        investmentFirmsName: '', // 意向金融/金融机构名称
        intendedFinancingAmount: '', // 拟融资金额
        financingPurpose: '', // 融资用途
        financingTermId: '', // 融资期限Id
        financingTermName: '', // 融资期限名称
        guaranteeTypeId: '', // 可提供担保方式id
        guaranteeTypeName: '', // 可提供担保类型名称
        guaranteeInstitutionState: '', // 金融机构-担保机构: 0不需要, 1需要
        guaranteeInstitutionId: '', // 金融机构-担保机构id
        guaranteeInstitutionName: '', // 金融机构-担保机构名称
        // 企业信息
        enterpriseName: '', // 企业名称
        organizationCode: '', // 组织机构代码
        legalPerson: '', // 企业法人
        legalPersonPhone: '', // 	企业法人联系方式
        financialLeader: '', // 	财务负责人
        financialLeaderPhone: '', // 财务负责人联系方式
        contactPerson: '', // 联系人
        contactPersonPhone: '', // 联系方式
        establishDate: '', // 成立时间
        taxLocation: '', // 纳税地点
        registeredAddress: { // 注册地址
          province: '', // 省
          city: '', // 市
          area: '' // 区
        },
        registeredAddressDetail: '', // 注册地详细地址
        physicalAddress: { // 实际地址json
          province: '', // 省
          city: '', // 市
          area: '' // 区
        },
        mainProduct: '', // 经营产品
        lastYearTotalAssets: '', // 上年度末总资产
        lastYearSalesRevenue: '', // 上年度销售收入
        physicalAddressDetail: '', // 实际地址详细地址
        guaranteeStatus: '', // 审核状态: 1待审核, 2不通过 3退回, 4通过, 5未担保, 6拒绝担保, 7已担保
        auditOpinion: '', // 审核意见
        fileList: []
      },
      fileList: [],
      rules: {},
    };
  },

  created() {
    console.log(this.isLargeMarket)
    this.getData();
    this.getGroup()
  },
  methods: {
			beforeAvatarUploadLimit(file) {
				if(this.examinationResultsSrc.length === 1) {
					return this.$message.warning('您已经上传了一份报告，请删除后重新上传')
				}
				const isLt2M = file.size / 1024 / 1024 < 100;
				if (!isLt2M) {
					this.$message.error("上传文件大小不能超过 100MB!");
				}
				return isLt2M;
			},
			handleRemove(file, fileList, type) {
        this.fileList = fileList
				if(fileList.length === 0) {
					this.ruleForm.fileList = ""
				}else{
					this.ruleForm.fileList = JSON.stringify(fileList)
				}
			},
			handleAvatarSuccess(response, file, fileList, type) {
        if (response.code == 0) {
					this.fileList = fileList
					if(fileList.length === 0) {
						this.ruleForm.fileList = ""
					}else{
						this.ruleForm.fileList = JSON.stringify(fileList)
					}
				}
			},
    getData() {
    	this.http.post(this.urlConfig.devUrl+'apij2/admin-api/finance/needs-apply/approval/page',this.listQuery).then(res =>{
				if (res.code == 0) {
					this.tableData = res.data.data;
					this.total = res.data.total;
				}
			})
    },

    handleDownload(file) {
      console.log('handleDownload', file)
      if (file.url) {
        const url = file.url;
        DownLoadUrl(url);
      }
    },
    async open() {
      try {
        const res = await this.http.get(
          `${this.urlConfig.devUrl}apij2/admin-api/finance/needs-apply/getDetail?id=${this.queryId}`
        );

        if (res.code === 0) {
          this.ruleForm = res.data;
          this.registeredAddress = res.data.registeredAddress
              ? JSON.parse(res.data.registeredAddress) : [];
          this.physicalAddress = res.data.physicalAddress
              ? JSON.parse(res.data.physicalAddress) : [];
          this.ruleForm.area = JSON.parse(res.data.area) || null
          this.ruleForm['areaStr'] = Array.isArray(res.data.area) ? (res.data.area.join('')) : res.data.area
          this.ruleForm['industryStr'] = JSON.parse(res.data.industry)?.label
          this.ruleForm.industry = JSON.parse(res.data.industry)
        } else {
          this.ruleForm = {
              // 融资需求
            enterprisesHistoryId: '', // 企业快照id
            enterprisesHistoryName: '', // 企业快照名称
            investmentFirmsId: '', // 意向金融/投资机构id
            investmentFirmsName: '', // 意向金融/金融机构名称
            intendedFinancingAmount: '', // 拟融资金额
            financingPurpose: '', // 融资用途
            financingTermId: '', // 融资期限Id
            financingTermName: '', // 融资期限名称
            guaranteeTypeId: '', // 可提供担保方式id
            guaranteeTypeName: '', // 可提供担保类型名称
            guaranteeInstitutionState: '', // 金融机构-担保机构: 0不需要, 1需要
            guaranteeInstitutionId: '', // 金融机构-担保机构id
            guaranteeInstitutionName: '', // 金融机构-担保机构名称
            // 企业信息
            enterpriseName: '', // 企业名称
            organizationCode: '', // 组织机构代码
            legalPerson: '', // 企业法人
            legalPersonPhone: '', // 	企业法人联系方式
            financialLeader: '', // 	财务负责人
            financialLeaderPhone: '', // 财务负责人联系方式
            contactPerson: '', // 联系人
            contactPersonPhone: '', // 联系方式
            establishDate: '', // 成立时间
            taxLocation: '', // 纳税地点
            registeredAddress: { // 注册地址
              province: '', // 省
              city: '', // 市
              area: '' // 区
            },
            registeredAddressDetail: '', // 注册地详细地址
            physicalAddress: { // 实际地址json
              province: '', // 省
              city: '', // 市
              area: '' // 区
            },
            mainProduct: '', // 经营产品
            lastYearTotalAssets: '', // 上年度末总资产
            lastYearSalesRevenue: '', // 上年度销售收入
            physicalAddressDetail: '', // 实际地址详细地址
            approvalStatus: '', // 审核状态: 1待审核, 2不通过 3退回, 4通过, 5未担保, 6拒绝担保, 7已担保
            auditOpinion: '', // 审核意见
            fileList: []
          };
          this.dialogVisible = true;
        }
      } catch (e) {
        console.log(e);
      }
    },
    //选择页码
		handleCurrentChange(e) {
				this.listQuery.page = e;
				this.getData();
		},
    	// 获取数据字典
			getGroup() {
				let obj = {
					dictTypes: ["financial_financing_term", "corporate_financing_protection_method"]
				}
				this.http.post(`${urlConfig.devUrl}apij2/admin-api/system/dict-data/getGroup`, obj).then(
					(response) => {
						if (response.code == 0) {
							console.log('response', response)
							this.financingTermList = response.data.financial_financing_term
							this.guaranteeTypeList = response.data.corporate_financing_protection_method

							// this.ruleForm = response.data
						} else {
							this.$message.error(response.status);
						}
					},
					(error) => {}
				);
			},
    selectChange(e, list, props) {
				if(e) {
					this.ruleForm[props] = list.find(item => item.value === e).label
				}else{
					this.ruleForm[props] = ""
				}
				console.log("this.ruleForm[props]", this.ruleForm[props])
			},
    //搜索
    search() {
      this.listQuery.page = 1;
      this.getData();
    },
    //选择
    selectionChange(selection) {
      this.deleteRow = [];
      if (selection.length != 0) {
        let arr = [];
        selection.forEach((item) => {
          arr.push(item.id);
        });
        this.deleteRow = arr;
      }
    },
    //编辑
    handleEdit(row) {
      this.dialogFormVisible = true;
      this.Title = "编辑";
      this.dialogType = 'edit'
      this.queryId = row.id
      this.disabled = false;
    },
    resetForm() {
				this.ruleForm = {
					    // 融资需求
              enterprisesHistoryId: '', // 企业快照id
            enterprisesHistoryName: '', // 企业快照名称
            investmentFirmsId: '', // 意向金融/投资机构id
            investmentFirmsName: '', // 意向金融/金融机构名称
            intendedFinancingAmount: '', // 拟融资金额
            financingPurpose: '', // 融资用途
            financingTermId: '', // 融资期限Id
            financingTermName: '', // 融资期限名称
            guaranteeTypeId: '', // 可提供担保方式id
            guaranteeTypeName: '', // 可提供担保类型名称
            guaranteeInstitutionState: '', // 金融机构-担保机构: 0不需要, 1需要
            guaranteeInstitutionId: '', // 金融机构-担保机构id
            guaranteeInstitutionName: '', // 金融机构-担保机构名称
            // 企业信息
            enterpriseName: '', // 企业名称
            organizationCode: '', // 组织机构代码
            legalPerson: '', // 企业法人
            legalPersonPhone: '', // 	企业法人联系方式
            financialLeader: '', // 	财务负责人
            financialLeaderPhone: '', // 财务负责人联系方式
            contactPerson: '', // 联系人
            contactPersonPhone: '', // 联系方式
            establishDate: '', // 成立时间
            taxLocation: '', // 纳税地点
            registeredAddress: { // 注册地址
              province: '', // 省
              city: '', // 市
              area: '' // 区
            },
            registeredAddressDetail: '', // 注册地详细地址
            physicalAddress: { // 实际地址json
              province: '', // 省
              city: '', // 市
              area: '' // 区
            },
            mainProduct: '', // 经营产品
            lastYearTotalAssets: '', // 上年度末总资产
            lastYearSalesRevenue: '', // 上年度销售收入
            physicalAddressDetail: '', // 实际地址详细地址
            approvalStatus: '', // 审核状态: 1待审核, 2不通过 3退回, 4通过, 5未担保, 6拒绝担保, 7已担保
            auditOpinion: '', // 审核意见
            fileList: []
				}
			},
    //编辑
    handleDetail(row) {
      this.dialogFormVisible = true;
      this.Title = "详情";
      this.dialogType = 'detail'
      this.queryId = row.id
      this.disabled = true;
    },
    //城市选择
		citySelected(e) {
      console.log(e,'eeeeeee')
			// if(e.province.value){
			// this.ruleForm.physicalAddress.province = e.province.value
			// }
			// if(e.city.value){
			// this.ruleForm.physicalAddress.city  = e.city.value
			// }
			// if(e.area.value){
			// this.ruleForm.physicalAddress.area = e.area.value
			// }
		},

        		//城市选择
		citySelected1(e) {
			if(e.province.value){
			this.ruleForm.registeredAddress.province = e.province.value
			}
			if(e.city.value){
			this.ruleForm.registeredAddress.city  = e.city.value
			}
			if(e.area.value){
			this.ruleForm.registeredAddress.area = e.area.value
			}
		},
    //删除
    handleDelete(index, row) {
      const data = [
        row.id
      ]
      this.$confirm("此操作将批量删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.http
            .request(this.urlConfig.devUrl + "/apij2/admin-api/voucher/resource-technical-personnel/delete", {
              ids: data
            }, "delete")
            .then((res) => {
              if (res.code == 0) {
                this.listQuery.page = 1;
                this.getData();
                this.$message({
                  type: "success",
                  message: "删除成功",
                });

              } else {
                this.$message({
                  message: "失败！",
                  type: "error",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //取消
    closeForm(name) {
      this.dialogFormVisible = false;
      this.$refs[name].resetFields();
    },
    // 人才
    changeTalent(id) {
      console.log('id')
      const data = this.rencaiList.find(item => item.id == id);
      this.ruleForm.talentCategoryName = data.label;
    },
    // 技术领域
    changeTechFieldId(id) {
      const data = this.jishuList.find(item => item.id == id);
      this.ruleForm.techFieldName = data.label;
    },
    addData() {
      this.http.post(`${this.urlConfig.devUrl}apij2/admin-api/voucher/resource-technical-personnel/create`, this.ruleForm).then(res => {
        if (res.code === 0) {
          this.getData()
          this.dialogFormVisible = false;
          this.$message.success('新增成功');
        } else {
          this.$messgae.error('新增失败')
        }
      }).catch(e => {
        this.$messgae.error('新增失败')
      })
    },
    editData() {
      if(!this.ruleForm.investmentFirmsIds){
        this.ruleForm.investmentFirmsIds = [this.ruleForm.investmentFirmsId]
      }
      this.http.post(`${this.urlConfig.devUrl}apij2/admin-api/finance/needs-apply-record/approval`, {
        ...this.ruleForm,
        auditOpinion: this.ruleForm.auditOpinion,
        approvalStatus: this.ruleForm.guaranteeStatus,
        needsApplyId: this.queryId,
        fileList: this.ruleForm.fileList
      }).then(res => {
        if (res.code === 0) {
          this.registeredAddress = [];
          this.physicalAddress = [];
          this.getData()
          this.dialogFormVisible = false;
          this.$message.success('审核成功');
        } else {
          this.$messgae.error('审核失败')
        }
      }).catch(e => {
        this.$messgae.error('审核失败')
      })
    },
    //提交
    submitForm(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          // 新增提交
          this.addData()
        } else {
          return false;
        }
      });
    },
    updateSubmitForm(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          // 编辑提交
          this.editData()
        } else {
          return false;
        }
      });
    }
  },
};
</script>

<style scoped lang="scss">
.employment {
  height: 100%;
  width: 100%;
  .base-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    /deep/.el-input--suffix {
      width: 100%;
      margin: 0 15px;
    }
    .el-input {
      // width: 400px;
      margin: 0 15px;
    }
    .date-picker {
      margin: 0 15px;
      .el-range-separator {
        width: auto;
      }
    }
  }
  .base-table {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #eef1f6;
  }
}

.warrantDialog {
  .el-form-item__content {
    text-align: left;
  }
  .form-title {
    width: 100%;
    text-align: left;
    color: #623aa2;
    border-left: 5px solid #623aa2;
    border-bottom: 1px solid #623aa2;
    padding-left: 10px;
    font-size: 20px;
    margin-bottom: 20px;
    font-weight: 700;
  }
}
/*上传图片*/
.is_border {
  border: 1px dashed #ddd !important;
  border-radius: 5px;
  height: 154px !important;
  line-height: 154px !important;
}

.upload_btn {
  display: block;
  background-color: #00a1ff;
  font-weight: bold;
  color: #fff;
  padding: 2px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}

.upload_btn:hover {
  background-color: #13ce66;
}

.del_img {
  position: absolute;
  top: -7px;
  left: 224px;
  color: #00a1ff;
}

.del_img:hover {
  cursor: pointer;
  color: #f00;
}

.del_img i:before {
  font-size: 20px;
}

.img_border {
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  width: 243px;
  height: 154px;
  display: block;
}

.avatar-uploader {
  text-align: center;
  width: 243px;
  height: 198px;
}

/deep/ .el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .el-upload:hover {
  border-color: #409eff !important;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 243px;
  height: 154px;
  line-height: 154px;
  text-align: center;
}

/deep/ .upload-demo {
  margin-top: 10px;
  border: none;
  /deep/.el-upload {
    /deep/.el-button {
      font-size: 14px;
      font-family: Alibaba PuHuiTi;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      background: rgba(66, 141, 255, 1);
      border-radius: 18px;
      padding: 10px 25px;
    }
  }
}
</style>
